import cn from "classnames";
import React, { useState } from "react";
import Bid from "./bid";
import Main from "./main";

const DriverContacts = (props) => {
    const [tab, setTab] = useState("main");
    const [isValid, setIsValid] = useState(true);
    const cname = cn("card card-body mb-3", {
        "border-danger": !isValid,
    });
    return (
        <div className={cname}>
            <h5 className="mb-4">Список контактов для водителя</h5>
            <ul className="nav nav-tabs nav-fill">
                <li className="nav-item cursor-pointer">
                    <div
                        className={cn("nav-link", {
                            "active text-primary": tab === "main",
                            "text-muted": tab !== "main",
                        })}
                        onClick={setTab.bind(null, "main")}
                    >
                        Общие контакты
                    </div>
                </li>
                <li className="nav-item cursor-pointer">
                    <div
                        className={cn("nav-link", {
                            "active text-primary": tab === "bid",
                            "text-muted": tab !== "bid",
                        })}
                        onClick={setTab.bind(null, "bid")}
                    >
                        На основе текущей заявки
                    </div>
                </li>
            </ul>
            <div className="pt-4">
                {tab === "main" ? (
                    <Main {...props} setIsValid={setIsValid} />
                ) : (
                    <Bid {...props} setIsValid={setIsValid} />
                )}
            </div>
        </div>
    );
};

export default DriverContacts;
